import { createRoot } from 'react-dom/client'
import './styles/styles.scss'
import { App } from './App'

createRoot(document.getElementById('root')).render(<App />)
